import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Alert, Card, Checkbox, Chip, Stack, Typography } from '@mui/material';
import { GridRowSelectionModel } from '@mui/x-data-grid';
import React from 'react';
import { generatePath, useNavigate } from 'react-router-dom';

import { REPORTING_HUB_EDIT_DEFAULT_URL, REPORTING_HUB_EDIT_URL } from '../../constants/routeUrls';
import { ReportTemplate } from '../../validationSchemas/ReportTemplateSchema';

interface ReportTemplateItemProps {
  reportTemplate: ReportTemplate;
  ownerName: string;
  defaultTemplate?: boolean;
  selectedReportTemplateIds: GridRowSelectionModel;
  setSelectedReportTemplateIds: (ids: GridRowSelectionModel) => void;
}

function ReportTemplateItem({
  reportTemplate,
  ownerName,
  defaultTemplate = false,
  selectedReportTemplateIds,
  setSelectedReportTemplateIds,
}: ReportTemplateItemProps) {
  const navigate = useNavigate();

  const goToReportTemplate = () => {
    navigate(
      generatePath(defaultTemplate ? REPORTING_HUB_EDIT_DEFAULT_URL : REPORTING_HUB_EDIT_URL, {
        reportTemplateId: reportTemplate.templateId.toString(),
      })
    );
  };

  if (!reportTemplate) {
    return (
      <Card sx={{ p: 2 }}>
        <Alert severity="error">Unable to load</Alert>
      </Card>
    );
  }

  const sheetNames = [];
  reportTemplate.sheetObjects?.forEach((sheetObject) => {
    sheetNames.push(sheetObject.sheetName);
  });
  const description = sheetNames.join(', ');

  const onCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!setSelectedReportTemplateIds || !selectedReportTemplateIds) return;

    const { templateId } = reportTemplate;
    if (event.target.checked) {
      setSelectedReportTemplateIds([...selectedReportTemplateIds, templateId]);
    } else {
      setSelectedReportTemplateIds(selectedReportTemplateIds.filter((selectedId) => selectedId !== templateId));
    }
  };

  return (
    <Card sx={{ p: 2, pr: 1, height: '180px' }}>
      <Stack spacing={2}>
        <Stack direction="row" justifyContent="space-between">
          <Stack
            spacing={1}
            sx={{ height: '140px', overflowY: 'scroll', cursor: 'pointer' }}
            onClick={goToReportTemplate}
          >
            <Typography variant="h5">{reportTemplate.reportName}</Typography>
            <Typography variant="body1">{description}</Typography>
          </Stack>
          <Stack>
            <Checkbox
              checked={selectedReportTemplateIds?.includes(reportTemplate.templateId)}
              onChange={onCheckboxChange}
              sx={{ py: 0 }}
            />
          </Stack>
        </Stack>
        <Stack direction="row" justifyContent="space-between" onClick={goToReportTemplate} sx={{ cursor: 'pointer' }}>
          <Stack>
            {!defaultTemplate && ownerName && (
              <Chip
                color="info"
                label={ownerName}
                size="small"
                sx={{ borderRadius: '4px', fontSize: '10px', fontWeight: '600', cursor: 'pointer' }}
              />
            )}
          </Stack>
          <ArrowForwardIcon color="action" />
        </Stack>
      </Stack>
    </Card>
  );
}

export default ReportTemplateItem;
